// extracted by mini-css-extract-plugin
export default {"pagination":"pagination___GgO5o"};